import React from 'react';

type Props = {
  className?: string;
};

const Logo: React.FC<Props> = ({ className = '' }) => {
  return <div className={['logo', className].join(' ')} />;
};

export default Logo;
